function cyccopysku(){
  console.time('time1');
	var temp = $("<input>");
  $("body").append(temp);
 temp.val($($('.cycproductskutxt').get(0)).text()).select();
  document.execCommand("copy");
  temp.remove();
    console.timeEnd('time1');
	//$.notify("Sku Copied!", "success");
  $('.cycproductskucopy').hide();
$('.cycproductskucopied').show();

setTimeout(function () {
    $('.cycproductskucopied').hide();
    $('.cycproductskucopy').show();
}, 3000);

}



